/**
 * Garderobo Smart Search Widget
 * SaaS white-label search widget for e-commerce
 */

import App from './core/App.js';

let appInstance = null;

const GarderoboSearch = {
  /**
   * Initialize the widget
   * @param {Object} options - Configuration options
   */
  init(options) {
    if (appInstance) {
      console.warn('[GarderoboSearch] Already initialized. Call destroy() first.');
      return;
    }

    appInstance = new App(options);
    appInstance.init().catch((err) => {
      console.error('[GarderoboSearch] Initialization failed:', err);
    });
  },

  /**
   * Destroy the widget and clean up all DOM/listeners
   */
  destroy() {
    if (appInstance) {
      appInstance.destroy();
      appInstance = null;
    }
  },
};

export default GarderoboSearch;
